import React, { useCallback, useEffect } from 'react';
import { SharedIndex } from '../shared';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../../store/hooks';
import { getHarrisBMR } from '../../../shared/utils/utilFunctions';
import { metaDataSelector } from '../../../store/globalSelectors';
import {
  setHarrisBMR,
  setHarrisSummary,
  setHarrisSelection,
  setHarrisStressFactor,
  setHarrisActivityFactor,
  setHarrisActivityFactorPAL_Input,
  setHarrisActivityFactorPAL_Select
} from '../../../store/slices/metaDataSlice';

const HarrisBenedict = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { patientInformation, estimatingRequirements } =
    useAppSelector(metaDataSelector);
  const { metric } = patientInformation;
  const {
    selection,
    stressFactor,
    activityFactor,
    activityFactorPAL_Input,
    activityFactorPAL_Select
  } = estimatingRequirements.harrisBenedict;

  useEffect(() => {
    dispatch(
      setHarrisBMR(
        getHarrisBMR(
          patientInformation?.age?.years,
          patientInformation?.gender.toLowerCase(),
          metric?.estimatedDryWeight || metric?.weight,
          metric?.height
        )
      )
    );
  }, []);

  const getNextRoute = useCallback(() => {
    const active = location.pathname;
    const bothOpted = selection?.stressFactor && selection?.activityFactor;
    const stressOpted = selection?.stressFactor && !selection?.activityFactor;
    const activityOpted = !selection?.stressFactor && selection?.activityFactor;

    if (
      active === '/estimating-requirements/harrisBenedict' &&
      (bothOpted || activityOpted)
    ) {
      return '/estimating-requirements/harrisBenedict/activityOrPAL';
    }
    if (
      (active === '/estimating-requirements/harrisBenedict' && stressOpted) ||
      (active === '/estimating-requirements/harrisBenedict/activityOrPAL' &&
        selection.stressFactor)
    ) {
      return '/estimating-requirements/harrisBenedict/stressFactor';
    }
    return patientInformation.type === 'PAEDIATRIC'
      ? '/estimating-requirements/paediatric-energy'
      : '/estimating-requirements/protein';
  }, [selection.stressFactor, selection.activityFactor, location.pathname]);

  return (
    <SharedIndex
      title={'HARRIS BENEDICT'}
      selection={selection}
      stressFactor={stressFactor}
      nextPageRoute={getNextRoute()}
      setSummaryVal={setHarrisSummary}
      activityFactor={activityFactor}
      setStressFactor={setHarrisStressFactor}
      handleSelectionToggle={setHarrisSelection}
      setActivityFactor={setHarrisActivityFactor}
      activityFactorPAL_Input={activityFactorPAL_Input}
      activityFactorPAL_Select={activityFactorPAL_Select}
      BMRVal={estimatingRequirements.harrisBenedict.bmr}
      summary={estimatingRequirements.harrisBenedict.summary}
      setActivityFactorPAL_Input={setHarrisActivityFactorPAL_Input}
      setActivityFactorPAL_Select={setHarrisActivityFactorPAL_Select}
    />
  );
};

export { HarrisBenedict };
